@if (craningBookingUtils.isExploitantView()) {
    <div class="content-container bg-white">
        @if (!craningBookingId) {
            <h2>
                {{
                    'services.craning.booking.print.period' | translate : {
                        from: from | date : formats.date,
                        to: to | date : formats.date
                    }
                }}
            </h2>
        } @else {
            @for (booking of craningBookings; track booking) {
                <div class="booking single">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3 translate>services.craning.booking.print.slot.title</h3>
                            <table class="table table-borderless slot"
                                   aria-hidden="true">
                                <tbody>
                                <tr>
                                    <td translate>services.craning.booking.print.slot.date</td>
                                    <td translate>services.craning.booking.print.slot.time</td>
                                    <td translate>services.craning.booking.print.slot.duration</td>
                                </tr>
                                <tr>
                                    <td>{{ booking.craningBookingSlot.date | date : formats.date }}</td>
                                    <td>{{ DateUtils.formatTime(booking.craningBookingSlot.startTime) }}</td>
                                    <td>{{ DateUtils.formatTime(craningBookingUtils.calculateCraningBookingDuration(booking.craningBookingSlot)) }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <h3 translate>services.craning.booking.form.debtor.other</h3>
                            <table class="table table-borderless no-padding"
                                   aria-hidden="true">
                                <tbody>
                                <tr>
                                    <td translate>services.craning.booking.form.debtor.name</td>
                                    <td>{{ booking.customer?.firstName || booking.visitorFirstName }} {{ booking.customer?.lastName || booking.visitorLastName }}</td>
                                </tr>
                                <tr>
                                    <td translate>bookings.modal.user.street</td>
                                    <td>{{ booking.customer?.street || booking.visitorStreet }}</td>
                                </tr>
                                <tr>
                                    <td translate>bookings.modal.user.city</td>
                                    <td>{{ booking.customer?.postalCode || booking.visitorPostalCode }} {{ booking.customer?.city || booking.visitorCity }}</td>
                                </tr>
                                <tr>
                                    <td translate>bookings.modal.user.country</td>
                                    <td>{{ booking.customer?.country || booking.visitorCountry }}</td>
                                </tr>
                                <tr>
                                    <td translate>bookings.modal.user.email</td>
                                    <td>{{ booking.customer?.email || booking.visitorEmail }}</td>
                                </tr>
                                <tr>
                                    <td translate>bookings.modal.user.phoneNumber</td>
                                    <td>{{ booking.customer?.phone || booking.visitorMobilePhone }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="col-sm-6">
                            <h3 translate>mooringPlace.modal.boatInformationTitle</h3>
                            <table class="table table-borderless boat"
                                   aria-hidden="true">
                                <tbody>
                                <tr>
                                    <td translate>mooringPlace.modal.boatRegistrationNumber</td>
                                    <td>{{ craningBookingUtils.getBoatLabel(booking.mooringPlace) || booking.visitorBoatRegistrationNumber }}</td>
                                </tr>
                                <tr>
                                    <td translate>mooringPlace.modal.boatWeight</td>
                                    <td> {{ (booking.mooringPlace?.boatWeightInKg || booking.visitorBoatWeightInKg) | numberFormat: GesConstants.defaultNumeralFormat }}
                                        kg
                                    </td>
                                </tr>
                                <tr>
                                    <td translate>services.craning.booking.form.boatDimensions</td>
                                    <td>{{ (booking.mooringPlace?.boatWidthInMeter || booking.visitorBoatWidthInMeter) | numberFormat: GesConstants.defaultNumeralFormat }}
                                        m
                                        x {{ (booking.mooringPlace?.boatLengthInMeter || booking.visitorBoatLengthInMeter) | numberFormat: GesConstants.defaultNumeralFormat }}
                                        m
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <h3 translate>services.craning.booking.form.services</h3>
                            <table class="table table-borderless craning-services"
                                   aria-hidden="true">
                                <tbody>
                                    @for (craningService of craningServices; track craningService) {
                                        @if (isCraningServiceChosen(craningService, booking)) {
                                            <tr class="craning-service">
                                                <td colspan="2">{{ getCraningServiceLabel(craningService) }}</td>
                                            </tr>

                                            @for (question of craningService.questions; track question) {
                                                <tr class="question">
                                                    <td class="question">{{ getCraningServiceQuestionLabel(question) }}</td>
                                                    <td class="answer">
                                                        @if (!!getCraningServiceQuestionAnswer(craningService, question, booking)) {
                                                            <div>
                                                                @if (question.answerType === CraningServiceAnswerType.Boolean) {
                                                                    <div>
                                                                        @if (getCraningServiceQuestionAnswer(craningService, question, booking) === 'true') {
                                                                            {{ 'common.yes' | translate }}
                                                                        } @else {
                                                                            {{ 'common.no' | translate }}
                                                                        }
                                                                    </div>
                                                                } @else {
                                                                    {{ getCraningServiceQuestionAnswer(craningService, question, booking) }}
                                                                }
                                                            </div>
                                                        } @else {
                                                            -
                                                        }
                                                    </td>
                                                </tr>
                                            }
                                        }
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            }
        }

        @if (!craningBookingId && craningBookings.length > 0) {
            <ul class="booking multiple">
                @for (booking of craningBookings; track booking) {
                    <li>
                        <div class="customer">
                            <span class="time">
                              {{ DateUtils.formatTime(booking.craningBookingSlot.startTime) }}
                            </span>

                            <span class="date">
                              {{ booking.craningBookingSlot.date | date : formats.date }}
                            </span>

                            <span>
                              {{ booking.customer?.firstName || booking.visitorFirstName }} {{ booking.customer?.lastName || booking.visitorLastName }}
                            </span>

                            <span>
                              {{ booking.customer?.phone || booking.visitorMobilePhone }}
                            </span>
                        </div>
                        <div class="boat">
                            <span>
                              {{ booking.mooringPlace?.boatRegistrationNumber || booking.visitorBoatRegistrationNumber }}
                            </span>
                            <span>
                                {{ (booking.mooringPlace?.boatWeightInKg || booking.visitorBoatWeightInKg) | numberFormat: GesConstants.defaultNumeralFormat }}
                                kg
                            </span>
                        </div>

                        <ul class="services">
                            @for (craningService of craningServices; track craningService) {
                                @if (isCraningServiceChosen(craningService, booking)) {
                                    <li>
                                        <span class="service">
                                        {{ getCraningServiceLabel(craningService) }}
                                        </span>
                                        @if (craningService.questions.length > 0) {
                                            @for (question of craningService.questions; track question) {
                                                @if (!!getCraningServiceQuestionAnswer(craningService, question, booking)) {
                                                    <span class="question">
                                                        <span class="label">
                                                        {{ getCraningServiceQuestionLabel(question) }}
                                                        </span>
                                                        <span class="answer">
                                                            @switch (question.answerType) {
                                                                @case (CraningServiceAnswerType.Boolean) {
                                                                    @if (getCraningServiceQuestionAnswer(craningService, question, booking) === 'true') {
                                                                        {{ 'common.yes' | translate | uppercase }}
                                                                    } @else {
                                                                        {{ 'common.no' | translate | uppercase }}
                                                                    }
                                                                }
                                                                @default {
                                                                    {{ getCraningServiceQuestionAnswer(craningService, question, booking) }}
                                                                }
                                                            }
                                                        </span>
                                                    </span>
                                                }
                                            }
                                        }
                                    </li>
                                }
                            }
                        </ul>
                    </li>
                }
            </ul>
        }
    </div>
}
